import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib/store';
import {
  cancelPassAmcInformationRequest,
  failPassAmcInformation,
  setPassAmcInformation,
  setPassAmcInformationApi,
  updatePassAmcInformation,
  updatePassAmcInformationApi,
} from './pass-amc-information.actions';

/**
 * Service to handle async PassengerAmcInformation actions
 */
@Injectable()
export class PassAmcInformationEffect {
  /**
   * Set the state with the reply content, dispatch failPassengerAmcInformation if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setPassAmcInformationApi),
      fromApiEffectSwitchMap(
        (reply, action) => setPassAmcInformation({ model: reply, requestId: action.requestId }),
        (error, action) => of(failPassAmcInformation({ error, requestId: action.requestId })),
        cancelPassAmcInformationRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failPassengerAmcInformation if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updatePassAmcInformationApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updatePassAmcInformation({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failPassAmcInformation({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
